import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";

import { HttpclientService } from "../../../../shared";
import { Subject } from "rxjs";

import { wsInfractionMaintenanceToggleActiveParm } from "./wsInfractionMaintenanceInfractionInfo";
import { wsInfractionMaintenanceToggleBasicParm } from "./wsInfractionMaintenanceInfractionInfo";
import { wsInfractionMaintenanceInfractionGetDataParm } from "./wsInfractionMaintenanceInfractionModifyInfo";

import { wsInfractionMaintenanceInfractionAddParm } from "./wsInfractionMaintenanceInfractionModifyInfo";
import { wsInfractionMaintenanceInfractionUpdateParm } from "./wsInfractionMaintenanceInfractionModifyInfo";

@Injectable()
export class DataService_InfractionMaintenanceSBT {
	constructor(private http: HttpClient, private httpclientService: HttpclientService) {}

	//-----------------------------------------------------------------------------------------------------
	//
	//	InfractionMaintenanceInfractionSelectList
	//
	//-----------------------------------------------------------------------------------------------------
	InfractionMaintenanceInfractionSelectList(SchoolID: number) {
		var postResult$ = new Subject();
		var url = "SchoolSetupDisciplineSBM/InfractionMaintenanceInfractionSelectList";

		var promise$ = this.httpclientService.post(url, SchoolID);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});

		return postResult$;
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	InfractionMaintenanceToggleActive
	//
	//-----------------------------------------------------------------------------------------------------
	InfractionMaintenanceToggleActive(parms: wsInfractionMaintenanceToggleActiveParm) {
		var postResult$ = new Subject();
		var url = "SchoolSetupDisciplineSBM/InfractionMaintenanceToggleActive";

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});

		return postResult$;
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	InfractionMaintenanceToggleBasic
	//
	//-----------------------------------------------------------------------------------------------------
	InfractionMaintenanceToggleBasic(parms: wsInfractionMaintenanceToggleBasicParm) {
		var postResult$ = new Subject();
		var url = "SchoolSetupDisciplineSBM/InfractionMaintenanceToggleBasic";

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});

		return postResult$;
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	InfractionMaintenanceInfractionDataGet
	//
	//-----------------------------------------------------------------------------------------------------
	InfractionMaintenanceInfractionDataGet(parms: wsInfractionMaintenanceInfractionGetDataParm) {
		var postResult$ = new Subject();
		var url = "SchoolSetupDisciplineSBM/InfractionMaintenanceInfractionDataGet";

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});

		return postResult$;
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	InfractionMaintenanceInfractionAdd
	//
	//-----------------------------------------------------------------------------------------------------
	InfractionMaintenanceInfractionAdd(parms: wsInfractionMaintenanceInfractionAddParm) {
		var postResult$ = new Subject();
		var url = "SchoolSetupDisciplineSBM/InfractionMaintenanceInfractionAdd";

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});

		return postResult$;
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	InfractionMaintenanceInfractionUpdate
	//
	//-----------------------------------------------------------------------------------------------------
	InfractionMaintenanceInfractionUpdate(parms: wsInfractionMaintenanceInfractionUpdateParm) {
		var postResult$ = new Subject();
		var url = "SchoolSetupDisciplineSBM/InfractionMaintenanceInfractionUpdate";

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});

		return postResult$;
	}
}
